import styled from 'styled-components'
import { WithIndent } from './HOC'

const Flex = styled.div`
    display: flex;
    ${({ column }) => column && 'flex-direction: column'};
`;

export default WithIndent(Flex)